import React from 'react';
import Input from '../component/Input.js';
import {
  fetchCategories,
  fetchCategoriesItem,
  fetchCategoriesButton,
} from '../api/Api.js';
import MenuButton from '../component/menuHamburguerButton.js';
import Title from '../component/title.js';
import { db, storage } from '../config-firebase/firebase.js';
import { getFirestore, collection, doc, getDocs } from 'firebase/firestore';
import { addDoc, setDoc, updateDoc } from '../api/FirestoreInterceptor';
import { ref, uploadBytesResumable, getDownloadURL } from 'firebase/storage';
import { useNavigate } from 'react-router-dom';
import '../assets/styles/form.css';
import style from '../assets/styles/AddButtonForm.module.scss';
import { Link } from 'react-router-dom';

function AddButtonForm({
  dataObj,
  EditButtonTitle,
  setModalEditButton,
  fetchDataCollection,
}) {

  const navigate = useNavigate();
  const [form, setForm] = React.useState({
    title: '',
    category: '',
    parent: '',
    display: 'true',
    image: '',
  });
  const [categories, setCategories] = React.useState([]);
  const [url, setUrl] = React.useState('');
  const [progress, setProgress] = React.useState(0);

  //FIRESTORE

  React.useEffect(() => {
    const fetchCategory = async () => {
      const grabCategory = await fetchCategoriesButton('item');
      grabCategory.unshift('Selecione uma Categoria', 'main'); // Add a first option
      setCategories(grabCategory);
    };
    fetchCategory();
  }, []);

  React.useEffect(() => {
    const categories = fetchCategoriesButton('item');
  }, [dataObj]);

  React.useEffect(() => {
    if (dataObj) {
      setForm(dataObj);
    }
  }, [dataObj]);

  React.useEffect(() => {
    // Atualiza o valor de parent sempre que o título muda
    setForm((prevForm) => ({
      ...prevForm,
      parent: returningParent(prevForm.title),
    }));
  }, [form.title]);

  const [isSubmitting, setIsSubmitting] = React.useState(false);

  //Deletes all accents
  function normalizeString(str) {
    if (!str) return '';
    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }

  // Transform a sentence into a unique word with no accents and no upper case
  function returningParent(title) {
    if (!title) return '';
    const words = title.trim().split(/\s+/);
    let result = words
      .map((word) => normalizeString(word).toLowerCase())
      .join('');
    return result;
  }

  async function handleSubmit(event) {
    event.preventDefault(); // Impede o comportamento padrão de recarregar a página
    if (isSubmitting) return;

    if (!dataObj) {
      setIsSubmitting(true);
      try {
        await addDoc(collection(db, 'button'), form);
        setForm({
          title: '',
          category: '',
          parent: returningParent(''),
          display: 'true',
          image: '',
        });
        navigate('/');
      } catch (error) {
        console.error('Erro ao adicionar categoria:', error);
        alert('Erro ao criar categoria.');
      } finally {
        setIsSubmitting(false);
      }
    } else {
      setIsSubmitting(true);
      try {
        const oldTitle = dataObj.title || '';
        const oldParent = dataObj.parent || returningParent(oldTitle);
        const newTitle = form.title || '';
        const newParent = form.parent || returningParent(newTitle);

        // 1. Atualiza a categoria (documento do botão)
        await setDoc(doc(db, 'button', dataObj.id), form);

        // 2. Se o identificador da categoria mudou, relinka todos os pratos e subcategorias vinculados
        if (oldParent && newParent && oldParent !== newParent) {
          // Busca todos os pratos para relincar os vinculados à categoria antiga
          const itemsSnap = await getDocs(collection(db, 'item'));
          const dishesToRelink = itemsSnap.docs.filter((d) => {
            const cat = d.data().category;
            if (!cat) return false;
            return (
              cat === oldParent ||
              cat === oldTitle ||
              returningParent(cat) === oldParent
            );
          });

          // Busca todas as subcategorias vinculadas à categoria antiga
          const buttonsSnap = await getDocs(collection(db, 'button'));
          const buttonsToRelink = buttonsSnap.docs.filter((d) => {
            if (d.id === dataObj.id) return false;
            const cat = d.data().category;
            if (!cat) return false;
            return (
              cat === oldParent ||
              cat === oldTitle ||
              returningParent(cat) === oldParent
            );
          });

          // Atualiza todos os pratos em paralelo
          const dishUpdates = dishesToRelink.map((d) =>
            updateDoc(doc(db, 'item', d.id), { category: newParent })
          );

          // Atualiza todas as subcategorias em paralelo
          const buttonUpdates = buttonsToRelink.map((d) =>
            updateDoc(doc(db, 'button', d.id), { category: newParent })
          );

          await Promise.all([...dishUpdates, ...buttonUpdates]);

          console.log(
            `Categoria atualizada: ${dishesToRelink.length} prato(s) e ${buttonsToRelink.length} subcategoria(s) relinkados de "${oldParent}" para "${newParent}".`
          );

          if (dishesToRelink.length > 0 || buttonsToRelink.length > 0) {
            alert(
              `Categoria atualizada com sucesso!\n${dishesToRelink.length} prato(s) e ${buttonsToRelink.length} subcategoria(s) foram automaticamente relinkados para a nova categoria "${newTitle}".`
            );
          }
        }

        if (fetchDataCollection) await fetchDataCollection();
        if (setModalEditButton) {
          setModalEditButton(false);
        } else {
          navigate('/admin/EditButton/cat');
        }
      } catch (error) {
        console.error('Erro ao atualizar categoria e relinkar pratos:', error);
        alert('Ocorreu um erro ao atualizar a categoria.');
      } finally {
        setIsSubmitting(false);
      }
    }
  }

  function handleChange({ target }) {
    const { id, value } = target;
    setForm({ ...form, [id]: value });
  }

  const onfileChange = async (e) => {
    const file = e.target.files[0];
    if (file) {
      const path = `button/${file.name}`;
      const storageRef = ref(storage, path);
      const uploadTask = uploadBytesResumable(storageRef, file);
      uploadTask.on(
        'state_changed',
        (snapshot) => {
          // Progress function (optional)
          const progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          setProgress(progress);
        },
        (error) => {
          console.error(error);
        },
        async () => {
          // Handle successful uploads
          const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
          setUrl(downloadURL);
          form.image = downloadURL;
        }
      );
    }
  };

  return (
    <div className={style.containerAddButtonForm}>
      <div className={style.containerIcon}>
        <a
          href="https://docs.google.com/document/d/1JO_71SmMvI_lkzAerER1YuuM_F-0Sdp6-dJrdy7E1oQ/edit?tab=t.u9jzavkidgyy#heading=h.mh1tz61eu5kb"
          target="_blank"
          rel="noopener noreferrer"
          title="Abrir documentação"
        >
          <span>?</span>
        </a>
      </div>
      <Link to="/admin/admin" className={style.btnBack} title="Sair do Módulo">
        <svg viewBox="0 0 24 24" fill="none" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <path d="M19 12H5M12 19l-7-7 7-7"/>
        </svg>
      </Link>
      <div className="close-btn">
        {setModalEditButton ? (
          <button onClick={() => setModalEditButton(false)}>X</button>
        ) : (
          null
        )}
      </div>
      <Link to="/admin/admin">
        <Title
          mainTitle={
            EditButtonTitle ? EditButtonTitle : 'Adicione um novo botão'
          }
        />
      </Link>
      <form onSubmit={handleSubmit} className="m-1">
        <Input
          id="title"
          required
          label="Título"
          value={form.title}
          type="text"
          onChange={handleChange}
        />
        <div className="my-3">
          <label className="form-label">Categoria</label>
          <select
            id="category"
            className="form-select"
            value={form.category}
            required
            onChange={handleChange}
          >
            <option value="" disabled hidden>
              Selecione uma categoria
            </option>
            {categories &&
              categories.map((category, index) => (
                <option key={index} value={category}>
                  {category}
                </option>
              ))}
          </select>
        </div>
        <div className={style.hiddenInput}>
          <Input id="parent" value={form.parent} type="hidden" />
          <Input id="display" value={form.display} type="hidden" />
        </div>
        <Input
          id="image"
          label="imagem do totem"
          value={form.image}
          type="text"
          onChange={handleChange}
          title="Essa imagem só aparecerá no formato de Toten"
        />
        <div className={style.uploadImage}>
          <input type="file" onChange={onfileChange} />
          <progress value={progress} max="100" />
          {url && (
            <img className="image-preview" src={url} alt="Uploaded file" />
          )}
        </div>
        <div className={style.formButtonSubmit}>
          <button className="btn btn-primary" disabled={isSubmitting}>
            {isSubmitting ? 'Atualizando e relinkando...' : 'Enviar'}
          </button>
        </div>
      </form>
    </div>
  );
}
export default AddButtonForm;
